import { z } from 'zod'

import type { Exercise } from '../api/models'
import { ExerciseApi } from '../api'
import { getApiConfig } from './api-config'
import {
  nullableDateSchema,
  nullableStringSchema,
  yearWeekSchema,
} from './dal-utils'

export const exerciseWeekItemSchema = z.object({
  id: z.number(),
  date: z.date(),
  contentfulProgramId: nullableStringSchema,
  contentfulSubjectId: nullableStringSchema,
  contentfulWeekId: nullableStringSchema,
  contentfulSessionId: nullableStringSchema,
  timeSpent: z.number(),
  userId: z.number(),
  created: z.date(),
  modified: nullableDateSchema,
})

export type ExerciseWeekItem = z.infer<typeof exerciseWeekItemSchema>

function normalizeExerciseWeekItem(exercise: Exercise) {
  return exerciseWeekItemSchema.parse({
    id: exercise.id,
    date: exercise.date,
    contentfulProgramId: exercise.contentfulProgramId,
    contentfulSubjectId: exercise.contentfulSubjectId,
    contentfulWeekId: exercise.contentfulWeekId,
    contentfulSessionId: exercise.contentfulSessionId,
    timeSpent: exercise.timeSpent,
    userId: exercise.userId,
    created: exercise.created,
    modified: exercise.modified,
  })
}

export async function fetchExerciseWeek(
  yearWeek: string,
): Promise<ExerciseWeekItem[]> {
  const exerciseApi = new ExerciseApi(getApiConfig())
  const parsedYearWeek = yearWeekSchema.parse(yearWeek)
  const exercises = await exerciseApi.apiExerciseWeekGet({
    yearWeek: parsedYearWeek,
  })

  return z
    .array(exerciseWeekItemSchema)
    .parse(exercises.map(normalizeExerciseWeekItem))
}
